export const talentConfig = {
    data() {
        return {
            preReqList: {
                // general
                STR: [['generalBranch', 5]],
                AGI: [['generalBranch', 5]],
                INT: [['generalBranch', 5]],
                spell_deathknight_bloodpresence: [['generalBranch', 10]],
                spell_deathknight_frostpresence: [['generalBranch', 10]],
                CRIT: [['generalBranch', 15]],
                CRITDMG: [['generalBranch', 15]],
                spell_shadow_bloodboil: [['generalBranch', 15]],
                inv_elemental_mote_mana: [['generalBranch', 15]],
                spell_shadow_summonimp: [['generalBranch', 20]],
                ability_revendreth_druid: [['generalBranch', 30]],
                inv_misc_shadowegg: [['generalBranch', 35]],
                spell_holy_sealofsalvation: [['generalBranch', 45]],
                // warrior
                ability_hunter_harass: [],
                ability_warrior_punishingblow: [],
                spell_nature_thunderclap: [['warriorBranch', 5]],
                spell_holy_crusaderstrike: [['warriorBranch', 5], ['spell_nature_thunderclap', 3]],
                ability_paladin_swiftretribution: [['warriorBranch', 5], ['spell_nature_thunderclap', 1], ['spell_holy_crusaderstrike', 1]],
                ability_warrior_shieldbash: [['warriorBranch', 10]],
                inv_shield_05: [['warriorBranch', 10], ['ability_warrior_shieldbash', 1]],
                ability_defend: [['warriorBranch', 10]],
                ability_rogue_preparation: [['warriorBranch', 10]],
                warrior_talent_icon_stormbolt: [['warriorBranch', 15], ['spell_nature_thunderclap', 1]],
                inv_sword_48: [['warriorBranch', 15]],
                ability_deathknight_sanguinfortitude: [['warriorBranch', 15], ['ability_warrior_shieldbash', 4]],
                warrior_talent_icon_furyintheblood: [['warriorBranch', 15]],
                ability_blackhand_marked4death: [['warriorBranch', 20], ['inv_sword_48', 1]],
                ability_warrior_bloodfrenzy: [['warriorBranch', 20]],
                ability_warrior_revenge: [['warriorBranch', 25]],
                ability_warrior_shatteringthrow: [['warriorBranch', 25]],
                ability_deathknight_deathchain: [['warriorBranch', 30], ['inv_sword_48', 1], ['ability_blackhand_marked4death', 4]],
                ability_warrior_decisivestrike: [['warriorBranch', 30]],
                ability_warrior_colossussmash: [['warriorBranch', 30], ['ability_warrior_shatteringthrow', 1]],
                warrior_talent_icon_thunderstruck: [['warriorBranch', 35], ['spell_nature_thunderclap', 1], ['warrior_talent_icon_stormbolt', 1]],
                classicon_warrior: [['warriorBranch', 35]],
                ability_warrior_intensifyrage: [['warriorBranch', 35]],
                ability_whirlwind: [['warriorBranch', 40]],
                sunder_buff: [['warriorBranch', 40]],
                ability_racial_avatar: [['warriorBranch', 45]],
                spell_shadow_deathscream: [['warriorBranch', 45]],
                penetrate_buff: [['warriorBranch', 45]],
                ability_revendreth_paladin: [['warriorBranch', 50]],
                // // mage
                spell_frost_frostbolt02: [],
                spell_arcane_studentofmagic: [],
                spell_shadow_manaburn: [],
                inv_misc_food_73cinnamonroll: [['mageBranch', 5]],
                inv_misc_gem_sapphire_02: [['mageBranch', 5]],
                spell_fire_flamebolt: [['mageBranch', 5]],
                ability_socererking_arcanefortification: [['mageBranch', 5]],
                spell_frost_icestorm: [['mageBranch', 10]],
                spell_fire_soulburn: [['mageBranch', 10]],
                ability_warlock_burningembersblue: [['mageBranch', 15]],
                spell_fire_fireball02: [['mageBranch', 15], ['spell_fire_flamebolt', 4]],
                spell_fire_fire: [['mageBranch', 15], ['spell_fire_fireball02', 1]],
                spell_ice_lament: [['mageBranch', 20]],
                spell_shadow_detectlesserinvisibility: [['mageBranch', 20]],
                spell_fire_selfdestruct: [['mageBranch', 25]],
                spell_arcane_arcane01: [['mageBranch', 25]],
                ability_mage_arcanebarrage: [['mageBranch', 25]],
                spell_frost_coldhearted: [['mageBranch', 30]],
                spell_arcane_invocation: [['mageBranch', 30], ['spell_arcane_arcane01', 1]],
                spell_arcane_blast: [['mageBranch', 30]],
                spell_frost_wizardmark: [['mageBranch', 35]],
                spell_frost_iceshock: [['mageBranch', 35]],
                spell_fire_incinerate: [['mageBranch', 35]],
                spell_nature_starfall: [['mageBranch', 35]],
                spell_mage_icenova: [['mageBranch', 40]],
                spell_nature_purge: [['mageBranch', 40]],
                spell_fire_sealoffire: [['mageBranch', 45]],
                ability_mage_timewarp: [['mageBranch', 50]],
                // priest
                ability_pvp_innerrenewal: [],
                spell_arcane_mindmastery: [],
                spell_holy_renew: [['priestBranch', 5]],
                spell_holy_divineillumination: [['priestBranch', 5], ['spell_holy_renew', 1]],
                spell_holy_resurrection: [['priestBranch', 5]],
                spell_holy_flashheal: [['priestBranch', 10]],
                spell_holy_innerfire: [['priestBranch', 10]],
                spell_holy_testoffaith: [['priestBranch', 15], ['spell_holy_flashheal', 2]],
                spell_shadow_unholyfrenzy: [['priestBranch', 15]],
                spell_shadow_mindshear: [['priestBranch', 15], ['spell_shadow_unholyfrenzy', 1]],
                spell_shadow_shadowwordpain: [['priestBranch', 15]],
                spell_holy_powerwordshield: [['priestBranch', 20]],
                spell_shadow_shadowmend: [['priestBranch', 20]],
                spell_holy_dispelmagic: [['priestBranch', 25]],
                spell_holy_wordfortitude: [['priestBranch', 30]],
                spell_holy_holysmite: [['priestBranch', 30]],
                spell_shadow_misery: [['priestBranch', 30], ['spell_shadow_shadowmend', 1]],
                spell_arcane_massdispel: [['priestBranch', 30], ['spell_holy_dispelmagic', 1]],
                spell_shadow_demonicfortitude: [['priestBranch', 30]],
                spell_holy_powerwordbarrier: [['priestBranch', 35]],
                ability_priest_silence: [['priestBranch', 35]],
                ability_shaman_astralshift: [['priestBranch', 35]],
                ability_priest_flashoflight: [['priestBranch', 40]],
                spell_nature_nullifydisease: [['priestBranch', 40]],
                spell_holy_hopeandgrace: [['priestBranch', 45]],
                spell_holy_divineprotection: [['priestBranch', 45]],
                spell_holy_persuitofjustice: [['priestBranch', 50]],
                // // warlock
                // spell_warlock_soulburn: [['warriorBranch', 20]],
                // ability_warlock_jinx: [['warriorBranch', 25], ['spell_warlock_soulburn', 1]],
            },
            generalBranch: {
                generalBranch: {
                    name: '通用系',
                    desc: [''],
                    type: 'generalBranch',
                    iconSrc: "./icons/accessory/inv_jewelry_necklace_17.jpg",
                    maxLv: 100,
                    position: [-1, -1]
                },
                generalBranch2: {
                    name: '通用系自身点数',
                    desc: [''],
                    type: 'generalBranch2',
                    iconSrc: "./icons/accessory/inv_jewelry_necklace_17.jpg",
                    maxLv: 100,
                    position: [-1, -1]
                },
                ATK: {
                    name: '攻击',
                    desc: ['',
                        '提升2%攻击力',
                        '提升4%攻击力',
                        '提升6%攻击力',
                        '提升8%攻击力',
                        '提升10%攻击力',
                    ],
                    type: 'ATK',
                    iconSrc: "./icons/stat/atk.jpg",
                    maxLv: 5,
                    position: [0, 0],
                },
                SUNDER: {
                    name: '破甲',
                    desc: ['',
                        '提升2点破甲',
                        '提升4点破甲',
                        '提升6点破甲',
                        '提升8点破甲',
                        '提升10点破甲',
                    ],
                    type: 'SUNDER',
                    iconSrc: "./icons/stat/sunder.jpg",
                    maxLv: 5,
                    position: [1, 0],
                },
                DEF: {
                    name: '护甲',
                    desc: ['',
                        '提升2%护甲',
                        '提升4%护甲',
                        '提升6%护甲',
                        '提升8%护甲',
                        '提升10%护甲',
                    ],
                    type: 'DEF',
                    iconSrc: "./icons/stat/arm.jpg",
                    maxLv: 5,
                    position: [2, 0],
                },
                BLOCK: {
                    name: '格挡',
                    desc: ['',
                        '提升2%格挡',
                        '提升4%格挡',
                        '提升6%格挡',
                        '提升8%格挡',
                        '提升10%格挡',
                    ],
                    type: 'BLOCK',
                    iconSrc: "./icons/stat/block.jpg",
                    maxLv: 5,
                    position: [3, 0],
                },
                STR: {
                    name: '力量',
                    desc: ['',
                        '提升2%力量',
                        '提升4%力量',
                        '提升6%力量',
                        '提升8%力量',
                        '提升10%力量',
                    ],
                    type: 'STR',
                    iconSrc: "./icons/stat/str.jpg",
                    maxLv: 5,
                    position: [0, 1]
                },
                AGI: {
                    name: '敏捷',
                    desc: ['',
                        '提升2%敏捷',
                        '提升4%敏捷',
                        '提升6%敏捷',
                        '提升8%敏捷',
                        '提升10%敏捷',
                    ],
                    type: 'AGI',
                    iconSrc: "./icons/stat/agi.jpg",
                    maxLv: 5,
                    position: [1, 1]
                },
                INT: {
                    name: '智力',
                    desc: ['',
                        '提升2%智力',
                        '提升4%智力',
                        '提升6%智力',
                        '提升8%智力',
                        '提升10%智力',
                    ],
                    type: 'INT',
                    iconSrc: "./icons/stat/int.jpg",
                    maxLv: 5,
                    position: [2, 1]
                },
                spell_deathknight_bloodpresence: {
                    name: '生命摄取',
                    desc: [
                        '',
                        '战斗胜利后恢复5%失去的生命值',
                        '战斗胜利后恢复10%失去的生命值',
                        '战斗胜利后恢复15%失去的生命值',
                        '战斗胜利后恢复20%失去的生命值',
                        '战斗胜利后恢复25%失去的生命值',
                    ],
                    type: 'spell_deathknight_bloodpresence',
                    iconSrc: "./icons/spell/spell_deathknight_bloodpresence.jpg",
                    maxLv: 5,
                    position: [2, 2]
                },
                spell_deathknight_frostpresence: {
                    name: '能量摄取',
                    desc: [
                        '',
                        '战斗胜利后恢复5%失去的魔法值',
                        '战斗胜利后恢复10%失去的魔法值',
                        '战斗胜利后恢复15%失去的魔法值',
                        '战斗胜利后恢复20%失去的魔法值',
                        '战斗胜利后恢复25%失去的魔法值',
                    ],
                    type: 'spell_deathknight_frostpresence',
                    iconSrc: "./icons/spell/spell_deathknight_frostpresence.jpg",
                    maxLv: 5,
                    position: [3, 2]
                },
                CRIT: {
                    name: '暴击率',
                    desc: ['',
                        '提升1%暴击率',
                        '提升2%暴击率',
                        '提升3%暴击率',
                        '提升4%暴击率',
                        '提升5%暴击率',
                    ],
                    type: 'CRIT',
                    iconSrc: "./icons/stat/crit.jpg",
                    maxLv: 5,
                    position: [0, 3],
                },
                CRITDMG: {
                    name: '暴击伤害',
                    desc: ['',
                        '提升1%暴击伤害',
                        '提升2%暴击伤害',
                        '提升3%暴击伤害',
                        '提升4%暴击伤害',
                        '提升5%暴击伤害',
                    ],
                    type: 'CRITDMG',
                    iconSrc: "./icons/stat/critdmg.jpg",
                    maxLv: 5,
                    position: [1, 3],
                },
                spell_shadow_bloodboil: {
                    name: '生命残留',
                    desc: ['',
                        '击杀目标后恢复目标最大生命值1%的生命值, 上限为你的最大生命值的1%',
                        '击杀目标后恢复目标最大生命值1%的生命值, 上限为你的最大生命值的2%',
                        '击杀目标后恢复目标最大生命值1%的生命值, 上限为你的最大生命值的3%',
                        '击杀目标后恢复目标最大生命值1%的生命值, 上限为你的最大生命值的4%',
                        '击杀目标后恢复目标最大生命值1%的生命值, 上限为你的最大生命值的5%',
                        '击杀目标后恢复目标最大生命值1%的生命值, 上限为你的最大生命值的6%',
                        '击杀目标后恢复目标最大生命值1%的生命值, 上限为你的最大生命值的7%',
                        '击杀目标后恢复目标最大生命值1%的生命值, 上限为你的最大生命值的8%',
                        '击杀目标后恢复目标最大生命值1%的生命值, 上限为你的最大生命值的9%',
                    ],
                    type: 'spell_shadow_bloodboil',
                    iconSrc: "./icons/spell/spell_shadow_bloodboil.jpg",
                    maxLv: 9,
                    position: [2, 3],
                },
                inv_elemental_mote_mana: {
                    name: '法力残留',
                    desc: ['',
                        '击杀目标后恢复目标最大生命值0.25%的魔法值, 上限为你的最大魔法值的1%',
                        '击杀目标后恢复目标最大生命值0.25%的魔法值, 上限为你的最大魔法值的2%',
                        '击杀目标后恢复目标最大生命值0.25%的魔法值, 上限为你的最大魔法值的3%',
                        '击杀目标后恢复目标最大生命值0.25%的魔法值, 上限为你的最大魔法值的4%',
                        '击杀目标后恢复目标最大生命值0.25%的魔法值, 上限为你的最大魔法值的5%',
                        '击杀目标后恢复目标最大生命值0.25%的魔法值, 上限为你的最大魔法值的6%',
                        '击杀目标后恢复目标最大生命值0.25%的魔法值, 上限为你的最大魔法值的7%',
                        '击杀目标后恢复目标最大生命值0.25%的魔法值, 上限为你的最大魔法值的8%',
                        '击杀目标后恢复目标最大生命值0.25%的魔法值, 上限为你的最大魔法值的9%',
                    ],
                    type: 'inv_elemental_mote_mana',
                    iconSrc: "./icons/spell/inv_elemental_mote_mana.jpg",
                    maxLv: 9,
                    position: [3, 3],
                },
                spell_shadow_summonimp: {
                    name: '血之狂热',
                    desc: [
                        '',
                        '暴击后恢复0.25%最大生命值',
                        '暴击后恢复0.5%最大生命值',
                        '暴击后恢复0.75%最大生命值',
                        '暴击后恢复1%最大生命值',
                    ],
                    type: 'spell_shadow_summonimp',
                    iconSrc: "./icons/spell/spell_shadow_summonimp.jpg",
                    maxLv: 4,
                    position: [2, 4]
                },
                ability_revendreth_druid: {
                    name: '吸血',
                    desc: ['',
                        '恢复攻击/技能造成伤害的0.4%',
                        '恢复攻击/技能造成伤害的0.8%',
                        '恢复攻击/技能造成伤害的1.2%',
                        '恢复攻击/技能造成伤害的1.6%',
                        '恢复攻击/技能造成伤害的2%',
                    ],
                    type: 'ability_revendreth_druid',
                    iconSrc: "./icons/spell/ability_revendreth_druid.jpg",
                    maxLv: 5,
                    position: [3, 6]
                },
                inv_misc_shadowegg: {
                    name: '炼狱',
                    desc: ['',
                        '免疫一次死亡, 获得两层死亡免疫, 获得三层炼狱, 每次攻击减少一层, 消失时生命值低于50%直接死亡, 冷却10分钟',
                    ],
                    type: 'inv_misc_shadowegg',
                    iconSrc: "./icons/spell/inv_misc_shadowegg.jpg",
                    maxLv: 1,
                    position: [2, 7]
                },
                spell_holy_sealofsalvation: {
                    name: '希望人没事',
                    desc: ['',
                        '受到致命伤害时有0.25%恢复所有生命值, 然后再承受伤害',
                        '受到致命伤害时有0.5%恢复所有生命值, 然后再承受伤害',
                        '受到致命伤害时有0.75%恢复所有生命值, 然后再承受伤害',
                        '受到致命伤害时有1%恢复所有生命值, 然后再承受伤害',
                    ],
                    type: 'spell_holy_sealofsalvation',
                    iconSrc: "./icons/spell/spell_holy_sealofsalvation.jpg",
                    maxLv: 4,
                    position: [0, 9]
                },
            },
            warriorBranch: {
                warriorBranch: {
                    name: '战士系',
                    desc: [''],
                    type: 'warriorBranch',
                    iconSrc: "./icons/accessory/inv_jewelry_necklace_17.jpg",
                    maxLv: 100,
                    position: [-1, -1]
                },
                ability_hunter_harass: {
                    name: '复苏之风',
                    desc: ['',
                        '生命值自然恢复效果提升5%',
                        '生命值自然恢复效果提升10%',
                        '生命值自然恢复效果提升15%',
                        '生命值自然恢复效果提升20%',
                        '生命值自然恢复效果提升25%',
                    ],
                    type: 'ability_hunter_harass',
                    iconSrc: "./icons/spell/ability_hunter_harass.jpg",
                    maxLv: 5,
                    position: [2, 0]
                },
                ability_warrior_punishingblow: {
                    name: '压制',
                    desc: ['',
                        '对等级低于自己的目标额外造成10点物理伤害',
                        '对等级低于自己的目标额外造成20点物理伤害',
                        '对等级低于自己的目标额外造成30点物理伤害',
                        '对等级低于自己的目标额外造成40点物理伤害',
                        '对等级低于自己的目标额外造成50点物理伤害',
                    ],
                    type: 'ability_warrior_punishingblow',
                    iconSrc: "./icons/spell/ability_warrior_punishingblow.jpg",
                    maxLv: 5,
                    position: [4, 0]
                },
                spell_nature_thunderclap: {
                    name: '【技能】雷霆一击',
                    desc: [
                        '',
                        '造成攻击力*1.1点伤害',
                        '造成攻击力*1.2点伤害',
                        '造成攻击力*1.3点伤害',
                        '造成攻击力*1.4点伤害'
                    ],
                    type: 'spell_nature_thunderclap',
                    iconSrc: "./icons/spell/spell_nature_thunderclap.jpg",
                    maxLv: 4,
                    position: [0, 1]
                },
                spell_holy_crusaderstrike: {
                    name: '【技能】十字军打击',
                    desc: ['',
                        '造成攻击力*2点伤害',
                        '造成攻击力*2.5点伤害',
                    ],
                    type: 'spell_holy_crusaderstrike',
                    iconSrc: "./icons/spell/spell_holy_crusaderstrike.jpg",
                    maxLv: 2,
                    position: [1, 1],
                    right: true
                },
                ability_paladin_swiftretribution: {
                    name: '十字军之力',
                    desc: ['',
                        '使用雷霆一击后, 十字军打击获得1点充能',
                        '使用雷霆一击后, 十字军打击获得2点充能',
                        '使用雷霆一击后, 十字军打击获得3点充能',
                        '使用雷霆一击后, 十字军打击获得4点充能',
                        '使用雷霆一击后, 十字军打击获得5点充能',
                    ],
                    type: 'ability_paladin_swiftretribution',
                    iconSrc: "./icons/spell/ability_paladin_swiftretribution.jpg",
                    maxLv: 5,
                    position: [2, 1],
                    right: true
                },
                ability_defend: {
                    name: '格挡',
                    desc: ['',
                        '减少5点受到的物理伤害',
                        '减少10点受到的物理伤害',
                        '减少15点受到的物理伤害',
                        '减少20点受到的物理伤害',
                        '减少25点受到的物理伤害',
                    ],
                    type: 'ability_defend',
                    iconSrc: "./icons/spell/ability_defend.jpg",
                    maxLv: 5,
                    position: [4, 1],
                },
                ability_rogue_preparation: {
                    name: '战争印记',
                    desc: ['',
                        '每次攻击恢复5点生命值和魔法值以及0.2%最大生命值',
                        '每次攻击恢复10点生命值和魔法值以及0.4%最大生命值',
                        '每次攻击恢复15点生命值和魔法值以及0.6%最大生命值',
                        '每次攻击恢复20点生命值和魔法值以及0.8%最大生命值',
                        '每次攻击恢复25点生命值和魔法值以及1%最大生命值',
                    ],
                    type: 'ability_rogue_preparation',
                    iconSrc: "./icons/spell/ability_rogue_preparation.jpg",
                    maxLv: 5,
                    position: [4, 2],
                },
                ability_warrior_intensifyrage: {
                    name: '代偿',
                    desc: ['',
                        '使用生命值代替所有技能的魔法值消耗',
                    ],
                    type: 'ability_warrior_intensifyrage',
                    iconSrc: "./icons/spell/ability_warrior_intensifyrage.jpg",
                    maxLv: 1,
                    position: [3, 7],
                },
                ability_warrior_shieldbash: {
                    name: '盾击',
                    desc: ['',
                        '造成攻击力*0.5+护甲*0.4点伤害',
                        '造成攻击力*0.5+护甲*0.45点伤害',
                        '造成攻击力*0.5+护甲*0.5点伤害',
                        '造成攻击力*0.5+护甲*0.55点伤害'
                    ],
                    type: 'ability_warrior_shieldbash',
                    iconSrc: "./icons/spell/ability_warrior_shieldbash.jpg",
                    maxLv: 4,
                    position: [2, 2],
                },
                inv_shield_05: {
                    name: '盾牌猛击',
                    desc: ['',
                        '盾击有10%眩晕目标',
                        '盾击有20%眩晕目标',
                        '盾击有30%眩晕目标',
                        '盾击有40%眩晕目标'
                    ],
                    type: 'inv_shield_05',
                    iconSrc: "./icons/spell/inv_shield_05.jpg",
                    maxLv: 4,
                    position: [3, 2],
                    right: true
                },
                warrior_talent_icon_stormbolt: {
                    name: '风暴之锤',
                    desc: ['',
                        '雷霆一击有10%眩晕目标',
                        '雷霆一击有20%眩晕目标',
                        '雷霆一击有30%眩晕目标',
                        '雷霆一击有40%眩晕目标'
                    ],
                    type: 'warrior_talent_icon_stormbolt',
                    iconSrc: "./icons/spell/warrior_talent_icon_stormbolt.jpg",
                    maxLv: 4,
                    position: [0, 3],
                    down2: true
                },
                inv_sword_48: {
                    name: '屠杀',
                    desc: ['',
                        '造成攻击力*0.5点伤害, 对低于80%的目标造成额外攻击力*0.75点伤害',
                    ],
                    type: 'inv_sword_48',
                    iconSrc: "./icons/spell/inv_sword_48.jpg",
                    maxLv: 1,
                    position: [1, 3],
                },
                ability_deathknight_sanguinfortitude: {
                    name: '惩罚',
                    desc: ['',
                        '盾牌猛击造成的伤害提升5%, 并附加一层虚弱',
                        '盾牌猛击造成的伤害提升10%, 并附加两层虚弱',
                        '盾牌猛击造成的伤害提升15%, 并附加三层虚弱',
                        '盾牌猛击造成的伤害提升20%, 并附加四层虚弱',
                    ],
                    type: 'ability_deathknight_sanguinfortitude',
                    iconSrc: "./icons/spell/ability_deathknight_sanguinfortitude.jpg",
                    maxLv: 4,
                    position: [2, 3],
                    down: true
                },
                warrior_talent_icon_furyintheblood: {
                    name: '暴乱狂战士',
                    desc: ['',
                        '最终伤害提升1%, 受到的伤害提升0.5%',
                        '最终伤害提升2%, 受到的伤害提升1%',
                        '最终伤害提升3%, 受到的伤害提升1.5%',
                        '最终伤害提升4%, 受到的伤害提升2%',
                    ],
                    type: 'warrior_talent_icon_furyintheblood',
                    iconSrc: "./icons/spell/warrior_talent_icon_furyintheblood.jpg",
                    maxLv: 4,
                    position: [3, 3],
                },
                ability_blackhand_marked4death: {
                    name: '斩杀',
                    desc: ['',
                        '屠杀对低于50%的目标额外造成攻击力*1点伤害',
                        '屠杀对低于50%的目标额外造成攻击力*1.1点伤害',
                        '屠杀对低于50%的目标额外造成攻击力*1.2点伤害',
                        '屠杀对低于50%的目标额外造成攻击力*1.3点伤害',
                    ],
                    type: 'ability_blackhand_marked4death',
                    iconSrc: "./icons/spell/ability_blackhand_marked4death.jpg",
                    maxLv: 4,
                    position: [1, 4],
                    down: true
                },
                ability_warrior_bloodfrenzy: {
                    name: '浴血',
                    desc: ['',
                        '每失去25%生命值, 最终伤害提升0.5%',
                        '每失去20%生命值, 最终伤害提升0.5%',
                        '每失去15%生命值, 最终伤害提升0.5%',
                        '每失去10%生命值, 最终伤害提升0.5%',
                    ],
                    type: 'ability_warrior_bloodfrenzy',
                    iconSrc: "./icons/spell/ability_warrior_bloodfrenzy.jpg",
                    maxLv: 4,
                    position: [3, 4],
                },
                ability_warrior_revenge: {
                    name: '复仇',
                    desc: ['',
                        '如果目标类型击杀过你, 对其造成的最终伤害提升2%',
                        '如果目标类型击杀过你, 对其造成的最终伤害提升4%',
                        '如果目标类型击杀过你, 对其造成的最终伤害提升6%',
                        '如果目标类型击杀过你, 对其造成的最终伤害提升8%',
                        '如果目标类型击杀过你, 对其造成的最终伤害提升10%',
                    ],
                    type: 'ability_warrior_revenge',
                    iconSrc: "./icons/spell/ability_warrior_revenge.jpg",
                    maxLv: 5,
                    position: [2, 5],
                },
                ability_warrior_shatteringthrow: {
                    name: '【技能】碎裂投掷',
                    desc: ['',
                        '造成攻击力*1.1点伤害, 30%获得一层穿透效果',
                        '造成攻击力*1.2点伤害, 30%获得一层穿透效果',
                    ],
                    type: 'ability_warrior_shatteringthrow',
                    iconSrc: "./icons/spell/ability_warrior_shatteringthrow.jpg",
                    maxLv: 2,
                    position: [4, 5],
                },
                ability_deathknight_deathchain: {
                    name: '处刑',
                    desc: ['',
                        '对低于5%生命值的非BOSS型怪物使用屠杀时, 目标直接死亡',
                        '对低于10%生命值的非BOSS型怪物使用屠杀时, 目标直接死亡',
                    ],
                    type: 'ability_deathknight_deathchain',
                    iconSrc: "./icons/spell/ability_deathknight_deathchain.jpg",
                    maxLv: 2,
                    position: [1, 6],
                    down2: true
                },
                ability_warrior_decisivestrike: {
                    name: '重击',
                    desc: ['',
                        '普通攻击有1%对敌人附加一层眩晕效果',
                        '普通攻击有2%对敌人附加一层眩晕效果',
                        '普通攻击有3%对敌人附加一层眩晕效果',
                        '普通攻击有4%对敌人附加一层眩晕效果',
                        '普通攻击有5%对敌人附加一层眩晕效果',
                    ],
                    type: 'ability_warrior_decisivestrike',
                    iconSrc: "./icons/spell/ability_warrior_decisivestrike.jpg",
                    maxLv: 5,
                    position: [2, 6],
                },
                ability_warrior_colossussmash: {
                    name: '粉碎投掷',
                    desc: ['',
                        '使用碎裂投掷有40%获得一层穿甲',
                        '使用碎裂投掷有50%获得一层穿甲'
                    ],
                    type: 'ability_warrior_colossussmash',
                    iconSrc: "./icons/spell/ability_warrior_colossussmash.jpg",
                    maxLv: 2,
                    position: [4, 6],
                    down: true
                },
                warrior_talent_icon_thunderstruck: {
                    name: '无坚不摧之力',
                    desc: ['',
                        '雷霆一击伤害提升30%, 使用完后立刻获得3点充能'
                    ],
                    type: 'warrior_talent_icon_thunderstruck',
                    iconSrc: "./icons/spell/warrior_talent_icon_thunderstruck.jpg",
                    maxLv: 1,
                    position: [0, 7],
                    down4: true
                },
                classicon_warrior: {
                    name: '强化攻击',
                    desc: ['',
                        '普通攻击造成攻击力*1.05点伤害',
                        '普通攻击造成攻击力*1.1点伤害',
                        '普通攻击造成攻击力*1.15点伤害',
                        '普通攻击造成攻击力*1.2点伤害',
                        '普通攻击造成攻击力*1.25点伤害',
                    ],
                    type: 'classicon_warrior',
                    iconSrc: "./icons/spell/classicon_warrior.jpg",
                    maxLv: 5,
                    position: [2, 7],
                },
                ability_whirlwind: {
                    name: '剑刃风暴',
                    desc: ['',
                        '造成8次100+攻击力*0.5点伤害, 移除所有负面状态效果'],
                    type: 'ability_whirlwind',
                    iconSrc: "./icons/spell/ability_whirlwind.jpg",
                    maxLv: 1,
                    position: [3, 8],
                },
                sunder_buff: {
                    name: '破甲增幅',
                    desc: ['',
                        '破甲使攻击无视目标27%护甲',
                        '破甲使攻击无视目标29%护甲',
                        '破甲使攻击无视目标31%护甲',
                        '破甲使攻击无视目标33%护甲',
                        '破甲使攻击无视目标35%护甲',
                    ],
                    type: 'sunder_buff',
                    iconSrc: "./icons/stat/sunder.jpg",
                    maxLv: 5,
                    position: [4, 8],
                },
                penetrate_buff: {
                    name: '穿透增幅',
                    desc: ['',
                        '穿透使攻击伤害的11%无视护甲',
                        '穿透使攻击伤害的12%无视护甲',
                        '穿透使攻击伤害的13%无视护甲',
                        '穿透使攻击伤害的14%无视护甲',
                        '穿透使攻击伤害的15%无视护甲',
                    ],
                    type: 'penetrate_buff',
                    iconSrc: "./icons/buff/penetrate.jpg",
                    maxLv: 5,
                    position: [4, 9],
                },
                ability_revendreth_paladin: {
                    name: '【技能】血祭',
                    desc: ['',
                        '造成当前生命值*3点伤害, 获得一层吸收效果',
                        '造成当前生命值*4点伤害, 获得一层吸收效果',
                        '造成当前生命值*5点伤害, 获得一层吸收效果',
                    ],
                    type: 'ability_revendreth_paladin',
                    iconSrc: "./icons/spell/ability_revendreth_paladin.jpg",
                    maxLv: 3,
                    position: [0, 9]
                },
                spell_shadow_deathscream: {
                    name: '【技能】死亡嚎叫',
                    desc: ['',
                        '造成攻击力*1点伤害, 50%对敌人附加一层眩晕效果, 并获得一层吸血效果',
                    ],
                    type: 'spell_shadow_deathscream',
                    iconSrc: "./icons/spell/spell_shadow_deathscream.jpg",
                    maxLv: 1,
                    position: [2, 9]
                },
                ability_racial_avatar: {
                    name: '【技能】天神下凡',
                    desc: ['',
                        '最终伤害提升20%, 移除并免疫所有负面效果, 持续一分钟',
                    ],
                    type: 'ability_racial_avatar',
                    iconSrc: "./icons/spell/ability_racial_avatar.jpg",
                    maxLv: 1,
                    position: [1, 10]
                },
                // warrior_talent_icon_innerrage: {
                //     name: '【技能】鲁莽',
                //     desc: [''],
                //     type: 'warrior_talent_icon_innerrage',
                //     iconSrc: "./icons/spell/warrior_talent_icon_innerrage.jpg",
                //     maxLv: 3,
                //     position: [2, 9]
                // }
            },
            mageBranch: {
                mageBranch: {
                    name: '法师系',
                    desc: [''],
                    type: 'mageBranch',
                    iconSrc: "./icons/accessory/inv_jewelry_necklace_17.jpg",
                    maxLv: 100,
                    position: [-1, -1]
                },
                spell_frost_frostbolt02: {
                    name: '【技能】寒冰箭',
                    desc: ['',
                        '代替普通攻击, 造成法术强度*1点魔法术强度害, 消耗20点魔法值'
                    ],
                    type: 'spell_frost_frostbolt02',
                    iconSrc: "./icons/spell/mage/spell_frost_frostbolt02.jpg",
                    maxLv: 1,
                    position: [0, 0]
                },
                spell_arcane_studentofmagic:{
                    name: '魔力源泉',
                    desc: ['',
                        '魔法值自然恢复效果提升5%',
                        '魔法值自然恢复效果提升10%',
                        '魔法值自然恢复效果提升15%',
                        '魔法值自然恢复效果提升20%',
                        '魔法值自然恢复效果提升25%',
                    ],
                    type: 'spell_arcane_studentofmagic',
                    iconSrc: './icons/spell/mage/spell_arcane_studentofmagic.jpg',
                    maxLv: 5,
                    position: [2, 0]
                },
                spell_shadow_manaburn:{
                    name: '奥术专注',
                    desc: ['',
                        '释放任意技能后有2%获得一层专注，使下一个技能不消耗任何魔法值',
                        '释放任意技能后有4%获得一层专注，使下一个技能不消耗任何魔法值',
                        '释放任意技能后有6%获得一层专注，使下一个技能不消耗任何魔法值',
                        '释放任意技能后有8%获得一层专注，使下一个技能不消耗任何魔法值',
                        '释放任意技能后有10%获得一层专注，使下一个技能不消耗任何魔法值',
                    ],
                    type: 'spell_shadow_manaburn',
                    iconSrc: './icons/spell/mage/spell_shadow_manaburn.jpg',
                    maxLv: 5,
                    position: [4, 0]
                },
                inv_misc_food_73cinnamonroll:{
                    name: '【技能】造餐术',
                    desc: ['',
                        '制造三个面包，用来立即回复100%的生命值，战斗期间无法使用'
                    ],
                    type: 'inv_misc_food_73cinnamonroll',
                    iconSrc: './icons/spell/mage/inv_misc_food_73cinnamonroll.jpg',
                    maxLv: 1,
                    position: [0, 1]
                },
                inv_misc_gem_sapphire_02:{
                    name: '【技能】制造法力宝石',
                    desc: ['',
                        '制造三颗法力宝石，用来立即回复100%的魔法值，战斗期间无法使用'
                    ],
                    type: 'inv_misc_gem_sapphire_02',
                    iconSrc: './icons/spell/mage/inv_misc_gem_sapphire_02.jpg',
                    maxLv: 1,
                    position: [1, 1]
                },
                spell_fire_flamebolt:{
                    name: '【技能】火球术',
                    desc: ['',
                        '投出一枚火球，造成法术强度*1.1点魔法伤害',
                        '投出一枚火球，造成法术强度*1.15点魔法伤害',
                        '投出一枚火球，造成法术强度*1.2点魔法伤害',
                        '投出一枚火球，造成法术强度*1.25点魔法伤害',
                    ],
                    type: 'spell_fire_flamebolt',
                    iconSrc: './icons/spell/mage/spell_fire_flamebolt.jpg',
                    maxLv: 4,
                    position: [2, 1],
                },
                ability_socererking_arcanefortification:{
                    name: '启发',
                    desc: ['',
                        '魔法值消耗降低1%',
                        '魔法值消耗降低2%',
                        '魔法值消耗降低3%',
                        '魔法值消耗降低4%',
                        '魔法值消耗降低5%',
                    ],
                    type: 'ability_socererking_arcanefortification',
                    iconSrc: './icons/spell/mage/ability_socererking_arcanefortification.jpg',
                    maxLv: 5,
                    position: [4, 1]
                },
                spell_frost_icestorm:{
                    name: '【技能】暴风雪',
                    desc: ['',
                        '目标区域骤然落下寒冰碎片，每秒对目标造成法术强度*0.15点魔法伤害，持续8秒',
                        '目标区域骤然落下寒冰碎片，每秒对目标造成法术强度*0.17点魔法伤害，持续8秒',
                        '目标区域骤然落下寒冰碎片，每秒对目标造成法术强度*0.19点魔法伤害，持续8秒',
                        '目标区域骤然落下寒冰碎片，每秒对目标造成法术强度*0.21点魔法伤害，持续8秒',
                    ],
                    type: 'spell_frost_icestorm',
                    iconSrc: './icons/spell/mage/spell_frost_icestorm.jpg',
                    maxLv: 4,
                    position: [0, 2]
                },
                spell_fire_soulburn:{
                    name: '【技能】灼烧',
                    desc: ['',
                        '造成法术强度*0.25点魔法伤害，并附加3层灼伤效果',
                        '造成法术强度*0.25点魔法伤害，并附加6层灼伤效果',
                        '造成法术强度*0.25点魔法伤害，并附加9层灼伤效果',
                    ],
                    type: 'spell_fire_soulburn',
                    iconSrc: './icons/spell/mage/spell_fire_soulburn.jpg',
                    maxLv: 3,
                    position: [3, 2]
                },
                ability_warlock_burningembersblue:{
                    name: '【技能】冰风暴',
                    desc: ['',
                        '释放寒冰风暴，每0.33秒对目标造成法术强度*0.08点魔法伤害，持续5秒',
                        '释放寒冰风暴，每0.33秒对目标造成法术强度*0.09点魔法伤害，持续5秒',
                        '释放寒冰风暴，每0.33秒对目标造成法术强度*0.1点魔法伤害，持续5秒',
                    ],
                    type: 'ability_warlock_burningembersblue',
                    iconSrc: './icons/spell/mage/ability_warlock_burningembersblue.jpg',
                    maxLv: 3,
                    position: [0, 3]
                },
                spell_fire_fireball02:{
                    name: '【技能】炎爆术',
                    desc: ['',
                        '发射一颗巨大的烈焰巨石，造成法术强度*2点魔法伤害',
                        '发射一颗巨大的烈焰巨石，造成法术强度*2.5点魔法伤害',
                        '发射一颗巨大的烈焰巨石，造成法术强度*3点魔法伤害',
                    ],
                    type: 'spell_fire_fireball02',
                    iconSrc: './icons/spell/mage/spell_fire_fireball02.jpg',
                    maxLv: 3,
                    position: [2, 3],
                    down2: true
                },
                spell_fire_fire:{
                    name: '纵火者',
                    desc: ['',
                        '火球术和炎爆术对当前生命值大于80%的目标必定暴击',
                    ],
                    type: 'spell_fire_fire',
                    iconSrc: './icons/spell/mage/spell_fire_fire.jpg',
                    maxLv: 1,
                    position: [3, 3],
                    right: true
                },
                spell_ice_lament:{
                    name: '【技能】寒冰护体',
                    desc: ['',
                        '为你施加寒冰护盾，吸收0.1*最大生命值*(1+全能*0.01)点伤害, 持续10秒',
                        '为你施加寒冰护盾，吸收0.1*最大生命值*(1+全能*0.01)点伤害, 持续15秒',
                        '为你施加寒冰护盾，吸收0.1*最大生命值*(1+全能*0.01)点伤害, 持续20秒'
                    ],
                    type: 'spell_ice_lament',
                    iconSrc: './icons/spell/mage/spell_ice_lament.jpg',
                    maxLv: 3,
                    position: [0, 4]
                },
                spell_shadow_detectlesserinvisibility:{
                    name: '【技能】法力护盾',
                    desc: ['',
                        '制造一个护盾，使用魔法值抵消受到的伤害，每点魔法值可抵消2点伤害，持续10秒'
                    ],
                    type: 'spell_shadow_detectlesserinvisibility',
                    iconSrc: './icons/spell/mage/spell_shadow_detectlesserinvisibility.jpg',
                    maxLv: 1,
                    position: [1, 4]
                },
                spell_fire_selfdestruct:{
                    name: '【技能】烈焰风暴',
                    desc: ['',
                        '对目标造成目标当前生命值*0.1点魔法伤害，并附加2层灼伤效果',
                        '对目标造成目标当前生命值*0.12点魔法伤害，并附加2层灼伤效果',
                        '对目标造成目标当前生命值*0.15点魔法伤害，并附加2层灼伤效果',
                    ],
                    type: 'spell_fire_selfdestruct',
                    iconSrc: './icons/spell/mage/spell_fire_selfdestruct.jpg',
                    maxLv: 3,
                    position: [2, 5]
                },
                spell_arcane_arcane01: {
                    name: '奥术充能',
                    desc: ['',
                        '释放任意法师技能有20%获得一层奥术充能，最多累计1层',
                        '释放任意法师技能有40%获得一层奥术充能，最多累计2层',
                        '释放任意法师技能有60%获得一层奥术充能，最多累计3层',
                        '释放任意法师技能有80%获得一层奥术充能，最多累计4层',
                        '释放任意法师技能有100%获得一层奥术充能，最多累计5层',
                    ],
                    type: 'spell_arcane_arcane01',
                    iconSrc: "./icons/spell/mage/spell_arcane_arcane01.jpg",
                    maxLv: 5,
                    position: [3, 5]
                },
                ability_mage_arcanebarrage:{
                    name: '【技能】奥术弹幕',
                    desc: ['',
                        '向敌方目标发射1-5发奥术能量箭矢，每发造成智力*1.6点魔法伤害。每层奥术充能使伤害提高25%',
                        '向敌方目标发射1-5发奥术能量箭矢，每发造成智力*1.7点魔法伤害。每层奥术充能使伤害提高25%',
                        '向敌方目标发射1-5发奥术能量箭矢，每发造成智力*1.8点魔法伤害。每层奥术充能使伤害提高25%',
                    ],
                    type: 'ability_mage_arcanebarrage',
                    iconSrc: './icons/spell/mage/ability_mage_arcanebarrage.jpg',
                    maxLv: 3,
                    position: [4, 5]
                },
                spell_frost_coldhearted:{
                    name: '【技能】冰冷血脉',
                    desc: ['',
                        '加快你的施法速度，使你的急速提高30，持续20秒'
                    ],
                    type: 'spell_frost_coldhearted',
                    iconSrc: './icons/spell/mage/spell_frost_coldhearted.jpg',
                    maxLv: 1,
                    position: [0, 6]
                },
                spell_arcane_invocation:{
                    name: '三之准则',
                    desc: ['',
                        '释放奥术弹幕、奥术飞弹、奥术冲击时，如果拥有三层或以上奥术充能，恢复6%最大魔法值',
                        '释放奥术弹幕、奥术飞弹、奥术冲击时，如果拥有三层或以上奥术充能，恢复9%最大魔法值',
                        '释放奥术弹幕、奥术飞弹、奥术冲击时，如果拥有三层或以上奥术充能，恢复12%最大魔法值',
                    ],
                    type: 'spell_arcane_invocation',
                    iconSrc: './icons/spell/mage/spell_arcane_invocation.jpg',
                    maxLv: 3,
                    position: [3, 6],
                    down: true
                },
                spell_arcane_blast:{
                    name: '【技能】奥术冲击',
                    desc: ['',
                        '用能量冲击目标，造成智力*3.5点魔法伤害。每层奥术充能使伤害提高60%，消耗的法力提高100%，增加3点充能',
                        '用能量冲击目标，造成智力*3.75点魔法伤害。每层奥术充能使伤害提高60%，消耗的法力提高100%，增加3点充能',
                        '用能量冲击目标，造成智力*4点魔法伤害。每层奥术充能使伤害提高60%，消耗的法力提高100%，增加3点充能',
                    ],
                    type: 'spell_arcane_blast',
                    iconSrc: './icons/spell/mage/spell_arcane_blast.jpg',
                    maxLv: 3,
                    position: [4, 6]
                },
                spell_frost_wizardmark:{
                    name: '【技能】急速冷却',
                    desc: ['',
                        '将暴风雪、冰风暴、寒冰护体和冰冷血脉完全充能'
                    ],
                    type: 'spell_frost_wizardmark',
                    iconSrc: './icons/spell/mage/spell_frost_wizardmark.jpg',
                    maxLv: 1,
                    position: [0, 7]
                },
                spell_frost_iceshock:{
                    name: '【技能】法术反制',
                    desc: ['',
                        '为目标附加沉默，使其五秒内无法释放技能'
                    ],
                    type: 'spell_frost_iceshock',
                    iconSrc: './icons/spell/mage/spell_frost_iceshock.jpg',
                    maxLv: 1,
                    position: [1, 7]
                },
                spell_fire_incinerate:{
                    name: '点燃',
                    desc: ['',
                        '你的火球术、灼烧、炎爆术和烈焰风暴会额外附加一层灼伤效果，使目标每秒受到当前生命值*0.01点魔法伤害，持续1秒'
                    ],
                    type: 'spell_fire_incinerate',
                    iconSrc: './icons/spell/mage/spell_fire_incinerate.jpg',
                    maxLv: 1,
                    position: [2, 7]
                },
                spell_nature_starfall:{
                    name: '【技能】奥术飞弹',
                    desc: ['',
                        '向敌人射出五波奥术飞弹，每发造成智力*1点魔法伤害。每层奥术充能额外发射一波奥术飞弹',
                        '向敌人射出五波奥术飞弹，每发造成智力*1.05点魔法伤害。每层奥术充能额外发射一波奥术飞弹',
                        '向敌人射出五波奥术飞弹，每发造成智力*1.1点魔法伤害。每层奥术充能额外发射一波奥术飞弹',
                    ],
                    type: 'spell_nature_starfall',
                    iconSrc: './icons/spell/mage/spell_nature_starfall.jpg',
                    maxLv: 3,
                    position: [4, 7]
                },
                spell_mage_icenova:{
                    name: '【技能】大法师之触',
                    desc: ['',
                        '对你当前的目标施加大法师之触，在8秒后目标将受到期间受到的伤害总量*0.25点魔法伤害'
                    ],
                    type: 'spell_mage_icenova',
                    iconSrc: './icons/spell/mage/spell_mage_icenova.jpg',
                    maxLv: 1,
                    position: [0, 8]
                },
                spell_nature_purge:{
                    name: '【技能】唤醒',
                    desc: ['',
                        '恢复精神*30点魔法值',
                        '恢复精神*40点魔法值',
                        '恢复精神*50点魔法值',
                    ],
                    type: 'spell_nature_purge',
                    iconSrc: './icons/spell/mage/spell_nature_purge.jpg',
                    maxLv: 3,
                    position: [3, 8]
                },
                spell_fire_sealoffire:{
                    name: '【技能】燃烧',
                    desc: ['',
                        '将自身包裹在烈焰之中，短时间内使你的法术爆击几率提高100%，持续10秒'
                    ],
                    type: 'spell_fire_sealoffire',
                    iconSrc: './icons/spell/mage/spell_fire_sealoffire.jpg',
                    maxLv: 1,
                    position: [2, 9]
                },
                ability_mage_timewarp:{
                    name: '【技能】时间扭曲',
                    desc: ['',
                        '将所有其他技能完全充能'
                    ],
                    type: 'ability_mage_timewarp',
                    iconSrc: './icons/spell/mage/ability_mage_timewarp.jpg',
                    maxLv: 1,
                    position: [2, 10]
                },                    
            },
            priestBranch: {
                priestBranch: {
                    name: '牧师系',
                    desc: [''],
                    type: 'priestBranch',
                    iconSrc: "./icons/accessory/inv_jewelry_necklace_17.jpg",
                    maxLv: 100,
                    position: [-1, -1]
                },
                ability_pvp_innerrenewal:{
                    name: '恢复信仰',
                    desc: ['',
                        '所有技能治疗量提高1%',
                        '所有技能治疗量提高2%',
                        '所有技能治疗量提高3%',
                        '所有技能治疗量提高4%',
                        '所有技能治疗量提高5%'
                    ],
                    type: 'ability_pvp_innerrenewal',
                    iconSrc: './icons/spell/priest/ability_pvp_innerrenewal.jpg',
                    maxLv: 5,
                    position: [2, 0]
                },
                spell_arcane_mindmastery:{
                    name: '启迪',
                    desc: ['',
                        '非战斗状态下, 你的法力恢复速度提高10%',
                        '非战斗状态下, 你的法力恢复速度提高20%',
                        '非战斗状态下, 你的法力恢复速度提高30%',
                        '非战斗状态下, 你的法力恢复速度提高40%',
                        '非战斗状态下, 你的法力恢复速度提高50%'
                    ],
                    type: 'spell_arcane_mindmastery',
                    iconSrc: './icons/spell/priest/spell_arcane_mindmastery.jpg',
                    maxLv: 5,
                    position: [4, 0]
                },    
                spell_holy_renew:{
                    name: '【技能】恢复',
                    desc: ['',
                        '满怀对圣光的信仰，每秒恢复法术强度*0.06点生命值，持续15秒',
                        '满怀对圣光的信仰，每秒恢复法术强度*0.07点生命值，持续15秒',
                        '满怀对圣光的信仰，每秒恢复法术强度*0.08点生命值，持续15秒',
                        '满怀对圣光的信仰，每秒恢复法术强度*0.09点生命值，持续15秒'
                    ],
                    type: 'spell_holy_renew',
                    iconSrc: './icons/spell/priest/spell_holy_renew.jpg',
                    maxLv: 4,
                    position: [0, 1]
                },
                spell_holy_divineillumination:{
                    name: '福音',
                    desc: ['',
                        '恢复效果的持续时间延长2秒',
                        '恢复效果的持续时间延长4秒',
                        '恢复效果的持续时间延长6秒'
                    ],
                    type: 'spell_holy_divineillumination',
                    iconSrc: './icons/spell/priest/spell_holy_divineillumination.jpg',
                    maxLv: 3,
                    position: [1, 1],
                    right: true
                },
                spell_holy_resurrection:{
                    name: '复活术',
                    desc: ['',
                        '死亡后立刻恢复15%生命值',
                        '死亡后立刻恢复30%生命值',
                        '死亡后立刻恢复45%生命值',
                        '死亡后立刻恢复60%生命值',
                        '死亡后立刻恢复75%生命值'
                    ],
                    type: 'spell_holy_resurrection',
                    iconSrc: './icons/spell/priest/spell_holy_resurrection.jpg',
                    maxLv: 5,
                    position: [4, 1]
                },
                spell_holy_flashheal:{
                    name: '【技能】快速治疗',
                    desc: ['',
                        '恢复自身法术强度*0.8点生命值',
                        '恢复自身法术强度*0.9点生命值',
                        '恢复自身法术强度*1点生命值',
                        '恢复自身法术强度*1.1点生命值'
                    ],
                    type: 'spell_holy_flashheal',
                    iconSrc: './icons/spell/priest/spell_holy_flashheal.jpg',
                    maxLv: 4,
                    position: [0, 2]
                },
                spell_holy_innerfire:{
                    name: '【技能】心灵之火',
                    desc: ['',
                        '提升10%攻击力、法术强度和500护甲，持续30秒',
                        '提升12%攻击力、法术强度和750护甲，持续30秒',
                        '提升14%攻击力、法术强度和1000护甲，持续30秒',
                    ],
                    type: 'spell_holy_innerfire',
                    iconSrc: './icons/spell/priest/spell_holy_innerfire.jpg',
                    maxLv: 3,
                    position: [2, 2]
                },
                spell_holy_testoffaith:{
                    name: '【技能】绝望祷言',
                    desc: ['',
                        '使最大生命值提高25%，持续10秒。同时立即为你恢复同样数量的生命值'
                    ],
                    type: 'spell_holy_testoffaith',
                    iconSrc: './icons/spell/priest/spell_holy_testoffaith.jpg',
                    maxLv: 1,
                    position: [0, 3],
                    down: true
                },
                spell_shadow_unholyfrenzy:{
                    name: '【技能】心灵震爆',
                    desc: ['',
                        '冲击目标的意识，造成智力*3点魔法伤害',
                        '冲击目标的意识，造成智力*3.5点魔法伤害',
                        '冲击目标的意识，造成智力*4点魔法伤害',
                        '冲击目标的意识，造成智力*4.5点魔法伤害'
                    ],
                    type: 'spell_shadow_unholyfrenzy',
                    iconSrc: './icons/spell/priest/spell_shadow_unholyfrenzy.jpg',
                    maxLv: 4,
                    position: [1, 3]
                },
                spell_shadow_mindshear:{
                    name: '精神灼伤',
                    desc: ['',
                        '心灵震爆有20%附带一层虚弱效果',
                        '心灵震爆有30%附带一层虚弱效果',
                        '心灵震爆有40%附带一层虚弱效果',
                        '心灵震爆有50%附带一层虚弱效果',
                    ],
                    type: 'spell_shadow_mindshear',
                    iconSrc: './icons/spell/priest/spell_shadow_mindshear.jpg',
                    maxLv: 4,
                    position: [2, 3],
                    right: true
                },
                spell_shadow_shadowwordpain:{
                    name: '【技能】暗言术：痛',
                    desc: ['',
                        '黑暗的咒语，造成法术强度*0.5点魔法伤害，并每秒造成法术强度*0.1点魔法伤害, 持续12秒',
                        '黑暗的咒语，造成法术强度*0.5点魔法伤害，并每秒造成法术强度*0.12点魔法伤害, 持续12秒',
                        '黑暗的咒语，造成法术强度*0.5点魔法伤害，并每秒造成法术强度*0.14点魔法伤害, 持续12秒',
                        '黑暗的咒语，造成法术强度*0.5点魔法伤害，并每秒造成法术强度*0.16点魔法伤害, 持续12秒',
                    ],
                    type: 'spell_shadow_shadowwordpain',
                    iconSrc: './icons/spell/priest/spell_shadow_shadowwordpain.jpg',
                    maxLv: 4,
                    position: [4, 3]
                },
                spell_holy_powerwordshield:{
                    name: '【技能】真言术：盾',
                    desc: ['',
                        '施加一个护盾，吸收法术强度*1*(1+全能*0.01)点伤害, 持续10秒',
                        '施加一个护盾，吸收法术强度*1.1*(1+全能*0.01)点伤害, 持续15秒',
                        '施加一个护盾，吸收法术强度*1.2*(1+全能*0.01)点伤害, 持续20秒',
                    ],
                    type: 'spell_holy_powerwordshield',
                    iconSrc: './icons/spell/priest/spell_holy_powerwordshield.jpg',
                    maxLv: 3,
                    position: [0, 4]
                },
                spell_shadow_shadowmend:{
                    name: '【技能】暗影愈合',
                    desc: ['',
                        '为其恢复法术强度*3.2点生命值，此后该目标将每秒受到法术强度*0.16点伤害，直到脱离战斗为止'
                    ],
                    type: 'spell_shadow_shadowmend',
                    iconSrc: './icons/spell/priest/spell_shadow_shadowmend.jpg',
                    maxLv: 1,
                    position: [2, 4]
                },
                spell_holy_dispelmagic:{
                    name: '【技能】纯净术',
                    desc: ['',
                        '驱散敌方目标所有增益魔法效果'
                    ],
                    type: 'spell_holy_dispelmagic',
                    iconSrc: './icons/spell/priest/spell_holy_dispelmagic.jpg',
                    maxLv: 1,
                    position: [3, 5]
                },
                spell_holy_wordfortitude:{
                    name: '【技能】真言术：韧',
                    desc: ['',
                        '注入活力，使耐力提高5%，持续1小时'
                    ],
                    type: 'spell_holy_wordfortitude',
                    iconSrc: './icons/spell/priest/spell_holy_wordfortitude.jpg',
                    maxLv: 1,
                    position: [0, 6]
                },
                spell_holy_holysmite:{
                    name: '【技能】惩击',
                    desc: ['',
                        '惩击一个敌人，造成法术强度*0.8点神圣伤害'
                    ],
                    type: 'spell_holy_holysmite',
                    iconSrc: './icons/spell/priest/spell_holy_holysmite.jpg',
                    maxLv: 1,
                    position: [1, 6]
                },
                spell_shadow_misery:{
                    name: '忍辱负重',
                    desc: ['',
                        '暗影愈合目标改为自身，治疗转为伤害，持续伤害转为治疗'
                    ],
                    type: 'spell_shadow_misery',
                    iconSrc: './icons/spell/priest/spell_shadow_misery.jpg',
                    maxLv: 1,
                    position: [2, 6],
                    down2: true
                },
                spell_arcane_massdispel:{
                    name: '驱散',
                    desc: ['',
                        '使纯净术驱散敌方目标所有增益魔法效果以及增益属性效果'
                    ],
                    type: 'spell_arcane_massdispel',
                    iconSrc: './icons/spell/priest/spell_arcane_massdispel.jpg',
                    maxLv: 1,
                    position: [3, 6],
                    down: true
                },
                spell_shadow_demonicfortitude:{
                    name: '【技能】暗言术：灭',
                    desc: ['',
                        '黑暗的咒语，对目标造成法术强度*0.85点点魔法伤害, 对生命值低于50%的目标所造成的伤害提高250%。如果目标没有被暗言术：灭消灭，则施法者会受到等量的伤害'
                    ], 
                    type: 'spell_shadow_demonicfortitude',
                    iconSrc: './icons/spell/priest/spell_shadow_demonicfortitude.jpg',
                    maxLv: 1,
                    position: [4, 6]
                },
                spell_holy_powerwordbarrier:{
                    name: '【技能】真言术：障',
                    desc: ['',
                        '召唤一道神圣的屏障，受到的最终伤害降低25%。持续10秒'
                    ],
                    type: 'spell_holy_powerwordbarrier',
                    iconSrc: './icons/spell/priest/spell_holy_powerwordbarrier.jpg',
                    maxLv: 1,
                    position: [0, 7]
                },
                ability_priest_silence:{
                    name: '【技能】沉默',
                    desc: ['',
                        '施加3层沉默，使目标无法使用任何技能',
                        '施加4层沉默，使目标无法使用任何技能',
                        '施加5层沉默，使目标无法使用任何技能'
                    ],
                    type: 'ability_priest_silence',
                    iconSrc: './icons/spell/priest/ability_priest_silence.jpg',
                    maxLv: 3,
                    position: [1, 7]
                },
                ability_shaman_astralshift:{
                    name: '灵魂护壳',
                    desc: ['',
                        '溢出的治疗效果将会转换为护盾，数值相当于治疗量的80%， 持续20秒'
                    ],
                    type: 'ability_shaman_astralshift',
                    iconSrc: './icons/spell/priest/ability_shaman_astralshift.jpg',
                    maxLv: 1,
                    position: [4, 7]
                },
                ability_priest_flashoflight:{
                    name: '【技能】真言术：慰',
                    desc: ['',
                        '以天堂之力攻击一名敌人，造成法术强度*0.8的魔法伤害，同时为你恢复5%的最大法力值',
                        '以天堂之力攻击一名敌人，造成法术强度*0.8的魔法伤害，同时为你恢复10%的最大法力值',
                    ],
                    type: 'ability_priest_flashoflight',
                    iconSrc: './icons/spell/priest/ability_priest_flashoflight.jpg',
                    maxLv: 2,
                    position: [0, 8]
                },
                spell_nature_nullifydisease:{
                    name: '【技能】魔法夺取',
                    desc: ['',
                        '夺取敌方目标身上的2个增益魔法效果',
                        '夺取敌方目标身上的3个增益魔法效果',
                        '夺取敌方目标身上的4个增益魔法效果'
                    ],
                    type: 'spell_nature_nullifydisease',
                    iconSrc: './icons/spell/priest/spell_nature_nullifydisease.jpg',
                    maxLv: 3,
                    position: [3, 8]
                },
                spell_holy_hopeandgrace:{
                    name: '优雅',
                    desc: ['',
                        '受到负面状态影响时有2%将其无视',
                        '受到负面状态影响时有4%将其无视',
                        '受到负面状态影响时有6%将其无视',
                    ],
                    type: 'spell_holy_hopeandgrace',
                    iconSrc: './icons/spell/priest/spell_holy_hopeandgrace.jpg',
                    maxLv: 3,
                    position: [0, 9]
                },
                spell_holy_divineprotection:{
                    name: '护盾戒律',
                    desc: ['',
                        '对生命值低于20%以下的目标使用治疗技能，提升5%法术强度以及治疗效果，持续10秒',
                        '对生命值低于35%以下的目标使用治疗技能，提升5%法术强度以及治疗效果，持续10秒',
                        '对生命值低于50%以下的目标使用治疗技能，提升5%法术强度以及治疗效果，持续10秒'
                    ],
                    type: 'spell_holy_divineprotection',
                    iconSrc: './icons/spell/priest/spell_holy_divineprotection.jpg',
                    maxLv: 3,
                    position: [2, 9]
                },
                spell_holy_persuitofjustice:{
                    name: '【技能】圣言术：静',
                    desc: ['',
                        '施展神迹，恢复最大生命值*1点生命值，溢出值将转为护盾，持续20秒'
                    ],
                    type: 'spell_holy_persuitofjustice',
                    iconSrc: './icons/spell/priest/spell_holy_persuitofjustice.jpg',
                    maxLv: 1,
                    position: [2, 10]
                },
            }
            // archived:{
                // ability_druid_starfall: {
                //     name: '【技能】无尽之星',
                //     desc: [''],
                //     type: 'ability_druid_starfall',
                //     iconSrc: "./icons/spell/ability_druid_starfall.jpg",
                //     maxLv: 1,
                //     position: [1, 8],
                //     down: true
                // },
            //     //warlock
            //     spell_warlock_soulburn: {
            //         name: '【技能】勾魂',
            //         desc: ['',
            //             '造成最大生命值*0.8点伤害',
            //             '造成最大生命值*0.9点伤害'
            //         ],
            //         type: 'spell_warlock_soulburn',
            //         iconSrc: "./icons/spell/spell_warlock_soulburn.jpg",
            //         maxLv: 2,
            //         position: [2, 4]
            //     },
            //     ability_warlock_jinx: {
            //         name: '夺魄',
            //         desc: ['',
            //             '使用勾魂后10%获得一层死亡免疫'
            //         ],
            //         type: 'ability_warlock_jinx',
            //         iconSrc: "./icons/spell/ability_warlock_jinx.jpg",
            //         maxLv: 1,
            //         position: [2, 5],
            //         down: true
            //     },
            // }
        }
    },
  }